import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'WarningActionBox',

  components: {
    ShButton,
  },

  props: {
    content: {
      type: String,
      default: 'Uwaga',
    },
    buttonContent: {
      type: String,
      default: 'Uruchom',
    },
  },
};
